import { useContext } from 'react';

import { FormattedInput, Input, Button, Form } from 'components/Form';
import { StateContext } from 'state/state-context';
import { Container } from 'components/Container/Container';
import { TextHeader } from 'components/Typography/TextHeader';

export const AccountDetails = () => {
  const { form, content } = useContext(StateContext);

  return (
    <Container>
      <TextHeader>{content('account_details_header')}</TextHeader>
      <p>{content('account_details_subHeader')}</p>
      <p>{content('account_details_subHeader_2')}</p>
      <Form>
        <FormattedInput name="sortCode" type="text" inputMode="numeric" format="##-##-##" />
        <Input name="accountNumber" type="text" inputMode="numeric" />
        <Button
          label="Next"
          linkTo={`/mobile-number`}
          isValid={() => form.fieldsAreValid(['accountNumber', 'sortCode'])}
          icon="right"
        />
      </Form>
    </Container>
  );
};
